const ListSkeleton = ({ label }: { label: string }) => (
  <div
    className="animate-pulse divide-y divide-gray-100 rounded-lg border border-gray-200 bg-white shadow-sm"
    role="status"
    aria-label={label}
  >
    {[0, 1, 2].map((row) => (
      <div key={row} className="flex items-center gap-6 px-4 py-4">
        <div className="h-4 w-32 rounded bg-gray-200" />
        <div className="h-4 flex-1 rounded bg-gray-100" />
        <div className="h-6 w-16 rounded-full bg-gray-200" />
        <div className="h-8 w-48 rounded bg-gray-100" />
      </div>
    ))}
  </div>
);

export default ListSkeleton;
